import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { addTraders } from '../../api/traders';
import MultProd from './MultProd';
import { getborders } from '../../api/border';

const AddTraderModal = ({ show, handleClose }) => {
  const [productList, setProductList] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState('');
  const [country, setCountry] = useState("");
  const [address, setAddress] = useState("");
  const [currency, setCurrency] = useState("");
  const [border, setBorder] = useState("");
  const [status, setStatus] = useState("");
  const [borderDatas, setBorderDatas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleInputChange = (setter) => (e) => setter(e.target.value);

  useEffect(() => {
    const fetchBorders = async () => {
      setLoading(true);
      try {
        getborders((result) => {
          if (result.ok === 1) {
            setBorderDatas(result.result);
          }
        });
      } catch (error) {
        console.error("Error fetching borders:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBorders();
  }, []);

  const validateFields = () => {
    if (!name) return "Full Name is required.";
    if (!email) return "Email is required.";
    if (!mobile) return "Mobile Number is required.";
    if (!country) return "Country is required.";
    if (!currency) return "Currency is required.";
    if (!status) return "Status is required.";
    if (!border) return "Border must be assigned.";
    if (productList.length === 0) return "At least one product must be assigned.";
    return null;
  };

  const clearForm = () => {
    setName('');
    setEmail('');
    setMobile('');
    setCountry('');
    setAddress('');
    setCurrency('');
    setBorder('');
    setStatus('');
    setProductList([]);
    setError('');
    setSuccess('');
  };

  const submitHandler = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');

    const validationError = validateFields();
    if (validationError) {
      setError(validationError);
      return;
    }

    setLoading(true);

    const productData = {
      products: JSON.stringify(productList),
      name,
      email,
      mobile,
      country,
      address,
      currency,
      border,
      status,
    };

    try {
      addTraders(productData, (result) => {
        setLoading(false);
        if (result.ok === 1) {
          setSuccess("Trader added successfully!");
          setTimeout(() => {
            clearForm();
            handleClose();
          }, 1500);
        } else {
          setError("Error adding trader. Please check your internet connection.");
        }
      });
    } catch (error) {
      setLoading(false);
      console.error("Error submitting form:", error);
      setError("An unexpected error occurred.");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold text-dark">
          <i className="bi bi-person-plus me-2 text-primary"></i>
          Add New Trader
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {/* Alert Messages */}
        {error && (
          <div className="alert alert-danger border-0 rounded-3 d-flex align-items-center mb-3">
            <i className="bi bi-exclamation-triangle-fill me-2"></i>
            {error}
          </div>
        )}
        {success && (
          <div className="alert alert-success border-0 rounded-3 d-flex align-items-center mb-3">
            <i className="bi bi-check-circle-fill me-2"></i>
            {success}
          </div>
        )}

        <form onSubmit={submitHandler}>
          {/* Personal Information */}
          <div className="mb-4">
            <h6 className="fw-bold mb-3 text-primary">
              <i className="bi bi-person me-2"></i>
              Personal Information
            </h6>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  Full Name <span className="text-danger">*</span>
                </label>
                <input 
                  onChange={handleInputChange(setName)} 
                  value={name} 
                  type="text" 
                  className="form-control form-control-lg border-0 bg-light" 
                  placeholder="Enter trader's full name"
                  style={{ borderRadius: '12px' }}
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  Email Address <span className="text-danger">*</span>
                </label>
                <input 
                  onChange={handleInputChange(setEmail)} 
                  value={email} 
                  type="email" 
                  className="form-control form-control-lg border-0 bg-light" 
                  placeholder="Enter email address"
                  style={{ borderRadius: '12px' }}
                  required
                />
              </div>
            </div>
          </div>

          {/* Contact & Location */}
          <div className="mb-4">
            <h6 className="fw-bold mb-3 text-success">
              <i className="bi bi-geo-alt me-2"></i>
              Contact & Location
            </h6>
            <div className="row g-3 mb-3">
              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  Mobile Number <span className="text-danger">*</span>
                </label>
                <input 
                  onChange={handleInputChange(setMobile)} 
                  value={mobile} 
                  type="tel" 
                  className="form-control form-control-lg border-0 bg-light" 
                  placeholder="Enter mobile number"
                  style={{ borderRadius: '12px' }}
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  Country <span className="text-danger">*</span>
                </label>
                <input 
                  onChange={handleInputChange(setCountry)} 
                  value={country} 
                  type="text" 
                  className="form-control form-control-lg border-0 bg-light" 
                  placeholder="Enter country"
                  style={{ borderRadius: '12px' }}
                  required
                />
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold">Address</label>
              <textarea 
                onChange={handleInputChange(setAddress)} 
                value={address} 
                className="form-control form-control-lg border-0 bg-light" 
                placeholder="Enter complete address"
                style={{ borderRadius: '12px' }}
                rows="3"
              />
            </div>
          </div>

          {/* Business Information */}
          <div className="mb-4">
            <h6 className="fw-bold mb-3 text-info">
              <i className="bi bi-briefcase me-2"></i>
              Business Information
            </h6>
            <div className="row g-3 mb-3">
              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  Currency <span className="text-danger">*</span>
                </label>
                <select 
                  onChange={handleInputChange(setCurrency)} 
                  value={currency} 
                  className="form-select form-select-lg border-0 bg-light"
                  style={{ borderRadius: '12px' }}
                  required
                >
                  <option value="">Select currency...</option>
                  <option value="TSH">TSH - Tanzanian Shilling</option>
                  <option value="KSH">KSH - Kenyan Shilling</option>
                  <option value="UGX">UGX - Ugandan Shilling</option>
                  <option value="USD">USD - US Dollar</option>
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  Assign Border <span className="text-danger">*</span>
                </label>
                <select 
                  onChange={handleInputChange(setBorder)} 
                  value={border} 
                  className="form-select form-select-lg border-0 bg-light"
                  style={{ borderRadius: '12px' }}
                  required
                >
                  <option value="">Select border crossing...</option>
                  {borderDatas.map((item) => (
                    <option key={item.id} value={item.name}>{item.name}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  Status <span className="text-danger">*</span>
                </label>
                <select 
                  onChange={handleInputChange(setStatus)} 
                  value={status} 
                  className="form-select form-select-lg border-0 bg-light"
                  style={{ borderRadius: '12px' }}
                  required
                >
                  <option value="">Select status...</option>
                  <option value="Approved">Approved</option>
                  <option value="Disabled">Disabled</option>
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  Assign Products <span className="text-danger">*</span>
                </label>
                <div className="bg-light rounded-3 p-3" style={{ borderRadius: '12px' }}>
                  <MultProd
                    productList={productList}
                    setProductList={setProductList}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="d-flex gap-3 justify-content-end">
            <button
              type="button"
              onClick={handleClose}
              className="btn btn-outline-secondary btn-lg px-4"
              style={{ borderRadius: '12px' }}
              disabled={loading}
            >
              <i className="bi bi-x-circle me-2"></i>
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary btn-lg px-4"
              style={{ borderRadius: '12px' }}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Adding Trader...
                </>
              ) : (
                <>
                  <i className="bi bi-person-plus me-2"></i>
                  Add Trader
                </>
              )}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddTraderModal;